import React, { Component } from "react";
import Slider from "react-slick";
// import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import heroVideo from './../../assets/media/video/video1.mp4'; // Replace with your actual video path

class Slider4 extends Component {
    render() {

        var settings = {
            dots: false,
            arrows: false,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true
        };

        return (
            <section className="hero hero-style-2">
                <div className="hero-slider">
                    <Slider {...settings}>
                        {/* Single Slide with Video */}
                        <div className="slide">
                            <div className="slide-inner" style={{ position: "relative" }}>
                                <div className="title-above-video">
                                    <h2 className="text-white" style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        color: "rgba(255, 255, 255, 0.3)",
                                        pointerEvents: "none",
                                        whiteSpace: "nowrap",
                                        zIndex: 1,
                                    }}>Enn Living Interiors Limited</h2>
                                    {/* <div className="btns">
                                        <Link to="/deals" className="btn theme-btn">Explore <i className="fa fa-angle-double-right"></i></Link>
                                    </div> */}
                                </div>
                                <video autoPlay muted loop className="slide-video">
                                    <source src={heroVideo} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>
        );
    }
}

export default Slider4;
